// extracted by mini-css-extract-plugin
export default {"descriptionText":"AUPFUL","emailVerificationResultContainer":"jnbyF_","ctaButton":"acFFrO","pageWrapper":"BHV72j"};